import CatalogBox from "./catalog.m";
import m from "mithril";
export default {
    view() {
        return (m("section", { class: "abos" },
            m(CatalogBox, null)));
    },
};
